import { Link } from '@tanstack/react-router';

import { cn } from '@/lib/utils';

import { PlaceholderImgPath } from '../../assets/images';
import type { Product } from '../../types/product.types';

type Props = {
  className?: string;
  product: Product;
};

const ProductCard = ({ className = '', product }: Props) => {
  return (
    <div
      className={cn(
        'group relative flex flex-col border border-amber-200 bg-white/30 p-2 transition-all hover:-translate-y-1',
        className,
      )}
    >
      <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-md bg-gray-200 transition-all group-hover:opacity-75">
        <img
          src={product.image_url || PlaceholderImgPath}
          alt={product.name}
          width={228}
          height={320}
          loading="lazy"
          className="h-full w-full object-cover object-center lg:h-full lg:w-full"
        />
      </div>
      <div className="flex flex-col">
        <div className="mt-4 flex flex-auto justify-between">
          <h3 className="max-w-[70%] text-sm text-gray-700">
            <Link to="/rendez-vous" search={{ prestation: product.slug ?? undefined }}>
              <span aria-hidden="true" className="absolute inset-0" />
              {product.name}
            </Link>
          </h3>
          <p className="block text-sm font-medium whitespace-nowrap text-gray-900">
            {product.price} €
          </p>
        </div>
        <p className="mt-auto pt-2 text-sm text-gray-500">
          À partir de {product.age_restriction ?? 18} ans
        </p>
      </div>
    </div>
  );
};

export default ProductCard;
